"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensitivityLabelPopover = void 0;
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var typestyle_1 = require("typestyle");
var Localize_1 = require("../../../../gen-src/Localize");
var LabelHelpers_1 = require("../LabelHelpers");
var Styles_1 = require("../Styles");
var LabelAssetContent_1 = require("../shared/LabelAssetContent");
var LabelPopoverDetail_1 = require("../shared/LabelPopoverDetail");
var LabelType_1 = require("../shared/LabelType");
var WarningPopover_1 = require("../warning/WarningPopover");
function SensitivityLabelPopover(props) {
    var anchoredSection = SensitivityLabelAnchoredSection(props);
    var parentedSection = SensitivityLabelParentedSection(props);
    var upstreamSection = SensitivityLabelUpstreamSection(props);
    var afterAnchored = !!anchoredSection && (!!parentedSection || !!upstreamSection);
    var afterParented = !!parentedSection && !!upstreamSection;
    if (!anchoredSection && !parentedSection && !upstreamSection) {
        return (react_1.default.createElement(react_1.default.Fragment, null));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        anchoredSection && anchoredSection,
        afterAnchored,
        parentedSection && parentedSection,
        afterParented && WarningPopover_1.sectionBreak,
        upstreamSection && upstreamSection));
}
exports.SensitivityLabelPopover = SensitivityLabelPopover;
function SensitivityLabelAnchoredSection(_a) {
    var anchored = _a.anchored, props = __rest(_a, ["anchored"]);
    var linksDisabled = react_1.default.useContext(LabelHelpers_1.LabelButtonContext).linksDisabled;
    if (!anchored || anchored.labels.length < 1) {
        return null;
    }
    var _b = props.content, contentName = _b.contentName, contentType = _b.contentType, contentUrl = _b.contentUrl, remoteType = _b.remoteType;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Styles_1.LabelGroupHeadingDiv, null, (0, LabelAssetContent_1.onThisAssetMessage)(contentType)),
        react_1.default.createElement(Styles_1.LabelAssetGroupDiv, null,
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAsset, { assetName: contentName !== null && contentName !== void 0 ? contentName : null, assetType: contentType !== null && contentType !== void 0 ? contentType : null, assetUrl: linksDisabled ? null : (contentUrl !== null && contentUrl !== void 0 ? contentUrl : null), remoteType: remoteType !== null && remoteType !== void 0 ? remoteType : undefined }),
            react_1.default.createElement(Styles_1.LabelLabelsGroupDiv, null,
                react_1.default.createElement(react_1.default.Fragment, null, anchored === null || anchored === void 0 ? void 0 : anchored.labels.map(function (i, index) {
                    return react_1.default.createElement(react_1.default.Fragment, { key: index },
                        react_1.default.createElement(SensitivityLabelExpandoSection, { label: i, contentName: contentName !== null && contentName !== void 0 ? contentName : null, shouldExpand: true }));
                }))))));
}
function SensitivityLabelExpandoSection(props) {
    var category = react_1.default.useContext(LabelHelpers_1.LabelsPopoverContext).category;
    var label = props.label, contentName = props.contentName, shouldExpand = props.shouldExpand;
    var _a = react_1.default.useState(shouldExpand), isExpanded = _a[0], setExpanded = _a[1];
    var buttonStyle = {
        $nest: {
            '& > [role="button"]': {
                width: '100%',
                background: '#FEF9EF',
            },
            '& > [role="button"] > div': {
                flexGrow: 1,
            },
        },
    };
    return react_1.default.createElement(widgets_1.ExpandoWidget, { className: (0, typestyle_1.style)(buttonStyle), direction: widgets_1.ExpandoDirection.Down, isExpanded: isExpanded, label: react_1.default.createElement(SensitivityLabelNonInteractiveButton, { testId: WarningPopover_1.LabelDetailChipId, title: (0, LabelType_1.localizeLabelTypeName)(label.type) }), onCollapse: function () { return setExpanded(false); }, onExpand: function () { return setExpanded(true); }, testId: 'expando-example', alignment: 'right', style: {
            display: 'block', //so expando content fills parent component
        } },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAuthorElement, __assign({}, label, { category: category })),
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailDateElement, __assign({}, label)),
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailMessageElement, __assign({}, label, { assetName: contentName }))));
}
function SensitivityLabelNonInteractiveButton(props) {
    var type = widgets_1.InlineAlertType.Warning;
    return (react_1.default.createElement(widgets_1.CompactInlineAlertWidget, { testId: props.testId, type: type }, props.title));
}
function SensitivityLabelParentedSection(_a) {
    var parented = _a.parented;
    if (!parented || parented.labels.length < 1) {
        return null;
    }
    return react_1.default.createElement(RenderSensitivityParentedSection, { labels: parented.labels, message: Localize_1.Messages.ColumnAssetMessage({
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            COLUMN_COUNT: parented.labels.length,
            // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
            COLUMN_COUNT_LOC: Localize_1.Formatters.formatCount(parented.labels.length)
        }) });
}
function RenderSensitivityParentedSection(props) {
    if (!props.labels || props.labels.length < 1) {
        return null;
    }
    var sensitivityLabels = props.labels.map(mapSensitivityLabelToLabelAssetProps);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Styles_1.LabelGroupHeadingDiv, null, props.message),
        react_1.default.createElement(Styles_1.LabelAssetGroupDiv, null,
            react_1.default.createElement(RenderParentedSensitivities, { labels: sensitivityLabels }))));
}
function mapSensitivityLabelToLabelAssetProps(label) {
    var _a, _b, _c, _d, _e, _f, _g;
    var content = label.content;
    return ({
        subjectArea: (_a = content === null || content === void 0 ? void 0 : content.subjectArea) !== null && _a !== void 0 ? _a : null,
        assetName: (_b = content === null || content === void 0 ? void 0 : content.contentName) !== null && _b !== void 0 ? _b : null,
        assetType: (_c = content === null || content === void 0 ? void 0 : content.contentType) !== null && _c !== void 0 ? _c : null,
        assetUrl: (_d = content === null || content === void 0 ? void 0 : content.contentUrl) !== null && _d !== void 0 ? _d : null,
        remoteType: (_e = content === null || content === void 0 ? void 0 : content.remoteType) !== null && _e !== void 0 ? _e : undefined,
        parentName: ('parent' in label ? (_f = label.parent) === null || _f === void 0 ? void 0 : _f.contentName : undefined),
        parentUrl: ('parent' in label ? (_g = label.parent) === null || _g === void 0 ? void 0 : _g.contentUrl : undefined),
        category: 'sensitivity',
        labels: [label]
    });
}
function RenderParentedSensitivities(props) {
    var linksDisabled = react_1.default.useContext(LabelHelpers_1.LabelButtonContext).linksDisabled;
    var collapse = react_1.default.useContext(LabelHelpers_1.LabelsPopoverContext).collapse;
    //group labels by parent table
    var sortedLabels = props.labels.sort(function (a, b) { var _a, _b; return ((_a = a.parentName) !== null && _a !== void 0 ? _a : '').localeCompare((_b = b.parentName) !== null && _b !== void 0 ? _b : ''); });
    switch (collapse) {
        case 'disallow':
        case 'allow': return (react_1.default.createElement(react_1.default.Fragment, null, sortedLabels.map(function (_a, i) {
            var assetName = _a.assetName, assetType = _a.assetType, assetUrl = _a.assetUrl, remoteType = _a.remoteType, parentName = _a.parentName, parentUrl = _a.parentUrl, labels = _a.labels;
            return (react_1.default.createElement(react_1.default.Fragment, { key: i },
                react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAsset, { assetName: assetName, assetType: assetType, assetUrl: linksDisabled ? null : assetUrl, remoteType: remoteType, parentName: parentName, parentUrl: parentUrl }),
                react_1.default.createElement(Styles_1.LabelLabelsGroupDiv, null,
                    react_1.default.createElement(RenderSensitivities, { assetName: assetName !== null && assetName !== void 0 ? assetName : null, labels: labels, keyIndex: "".concat(i) }))));
        })));
        case 'prefer': return (react_1.default.createElement(react_1.default.Fragment, null,
            sortedLabels.map(function (_a, i) {
                var assetName = _a.assetName, assetType = _a.assetType, assetUrl = _a.assetUrl, remoteType = _a.remoteType, parentName = _a.parentName, parentUrl = _a.parentUrl;
                return (react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAsset, { key: i, assetName: assetName, assetType: assetType, assetUrl: linksDisabled ? null : assetUrl, remoteType: remoteType, parentName: parentName, parentUrl: parentUrl }));
            }),
            react_1.default.createElement(Styles_1.LabelLabelsGroupDiv, null,
                react_1.default.createElement(SensitivityLabelNonInteractiveButton, { testId: WarningPopover_1.LabelDetailChipId, title: (0, LabelType_1.localizeLabelTypeName)(sortedLabels[0].labels[0].type) }))));
    }
}
function RenderSensitivities(props) {
    var labels = props.labels;
    return (react_1.default.createElement(react_1.default.Fragment, { key: props.keyIndex }, labels.map(function (i, index) {
        return react_1.default.createElement(react_1.default.Fragment, { key: index },
            react_1.default.createElement(RenderSensitivityDetail, __assign({}, props, { label: i })));
    })));
}
function RenderSensitivityDetail(props) {
    var _a;
    var _b = react_1.default.useContext(LabelHelpers_1.LabelsPopoverContext), category = _b.category, collapse = _b.collapse;
    var label = props.label, assetName = props.assetName;
    switch (collapse) {
        case 'disallow': return react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(SensitivityLabelNonInteractiveButton, { testId: WarningPopover_1.LabelDetailChipId, title: (0, LabelType_1.localizeLabelTypeName)(label.type) }),
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAuthorElement, __assign({}, label, { category: category })),
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailDateElement, __assign({}, label)),
            react_1.default.createElement(LabelPopoverDetail_1.LabelDetailMessageElement, __assign({}, label, { assetName: (_a = props.assetName) !== null && _a !== void 0 ? _a : null })));
        case 'allow': return react_1.default.createElement(SensitivityLabelExpandoSection, { label: label, contentName: assetName !== null && assetName !== void 0 ? assetName : null, shouldExpand: true });
        case 'prefer': return react_1.default.createElement(SensitivityLabelExpandoSection, { label: label, contentName: assetName !== null && assetName !== void 0 ? assetName : null, shouldExpand: false });
    }
}
function SensitivityLabelUpstreamSection(_a) {
    var _b;
    var upstream = _a.upstream, props = __rest(_a, ["upstream"]);
    var linksDisabled = react_1.default.useContext(LabelHelpers_1.LabelButtonContext).linksDisabled;
    if (!upstream || upstream.labels.length < 1) {
        return null;
    }
    var parentedSensitivityLabels = upstream.labels.filter(function (i) { return i.parent; });
    var nonParentedSensitivityLabels = upstream.labels
        .filter(function (i) { return !(i.parent); })
        .map(mapSensitivityLabelToLabelAssetProps)
        .sort(function (a, b) {
        var _a, _b;
        return ((_a = a.assetType) !== null && _a !== void 0 ? _a : '')
            .toString()
            .localeCompare(((_b = b.assetType) !== null && _b !== void 0 ? _b : '')
            .toString());
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Styles_1.LabelGroupHeadingDiv, null, (0, LabelAssetContent_1.upstreamOfThisAssetMessage)((_b = props.content.subjectArea) !== null && _b !== void 0 ? _b : null)),
        react_1.default.createElement(Styles_1.LabelAssetGroupDiv, null, nonParentedSensitivityLabels.map(function (_a, i) {
            var assetName = _a.assetName, assetType = _a.assetType, assetUrl = _a.assetUrl, remoteType = _a.remoteType, parentName = _a.parentName, parentUrl = _a.parentUrl, labels = _a.labels;
            return react_1.default.createElement(react_1.default.Fragment, { key: i },
                react_1.default.createElement(Styles_1.LabelGroupHeadingDiv, null, (0, LabelAssetContent_1.onThisAssetMessage)(assetType)),
                react_1.default.createElement(LabelPopoverDetail_1.LabelDetailAsset, { assetName: assetName !== null && assetName !== void 0 ? assetName : null, assetType: assetType !== null && assetType !== void 0 ? assetType : null, assetUrl: linksDisabled ? null : (assetUrl !== null && assetUrl !== void 0 ? assetUrl : null), remoteType: remoteType, parentName: parentName, parentUrl: parentUrl }),
                react_1.default.createElement(Styles_1.LabelLabelsGroupDiv, null,
                    react_1.default.createElement(RenderSensitivities, { assetName: assetName !== null && assetName !== void 0 ? assetName : null, labels: labels, keyIndex: "".concat(i) })));
        })),
        react_1.default.createElement(RenderSensitivityParentedSection, { labels: parentedSensitivityLabels, message: Localize_1.Messages.ColumnUpstreamMessage({
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                COLUMN_COUNT: parentedSensitivityLabels.length,
                // eslint-disable-next-line @typescript-eslint/restrict-plus-operands
                COLUMN_COUNT_LOC: Localize_1.Formatters.formatCount(parentedSensitivityLabels.length)
            }) })));
}
//# sourceMappingURL=SensitivityPopover.js.map